export default class ApplicationModel {
  constructor (data) {
    this.id = data.id
    this.versionId = data.versionId || ''
    this.type = data.type || ''
    this.name = data.name || ''
    this.businessArea = data.businessArea || ''
    this.firmReference = data.firmReference || ''
    this.status = data.status || ''
    this.vendor = data.vendor || ''
    this.docLink = data.docLink || ''
    this.lastAttestedBy = data.lastAttestedBy || ''
    this.lastAttestedAt = data.lastAttestedAt || ''
  }
}